import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>© ABC Daycare</p>
      <p>Since 2007</p>
      {/* <div className="social-media">
        <a href="#">Facebook</a>
        <a href="#">Twitter</a>
        <a href="#">Instagram</a>
      </div> */}
    </footer>
  );
}
